// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compare-institution {
  width: 100%;
}
.compare-institution .header {
  font-size: 40px;
}
.compare-institution .compare-list {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.compare-institution .compare-list .compare-item {
  position: relative;
  width: 24%;
  border: 1px solid var(--benchmarking-hover);
  background: var(--benchmarking-hover);
  padding: 10px;
  border-radius: 20px;
  height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.compare-institution .compare-list .compare-item .icon {
  width: 100%;
  display: flex;
  justify-content: center;
}
.compare-institution .compare-list .compare-item .icon svg {
  width: 50%;
  height: 120px;
}
.compare-institution .compare-list .compare-item button {
  position: absolute;
  bottom: 10px;
  width: 170px;
  height: 45px;
  border: 1px solid var(--benchmarking-color);
  border-radius: 20px;
  margin-bottom: 20px;
}
.compare-institution .compare-list .compare-item button:hover {
  cursor: pointer;
  background-color: var(--benchmarking-color);
  color: white;
}
.compare-institution .compare-list .compare-item-filled {
  position: relative;
  width: 24%;
  background: var(--benchmarking-hover);
  padding: 10px;
  border-radius: 20px;
  height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.compare-institution .compare-list .compare-item-filled .filters-keyword {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}
.compare-institution .compare-list .compare-item-filled .filters-keyword p {
  font-size: 14px;
  color: var(--dark-grey);
  margin-top: 4px !important;
}
.compare-institution .compare-list .compare-item-filled img {
  height: 50px;
  object-fit: cover;
}
.compare-institution .compare-list .compare-item-filled .name {
  margin-top: 10px !important;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}
.compare-institution .compare-list .compare-item-filled .basic-stat-institution {
  position: absolute;
  top: 130px;
  margin-top: 10px;
  width: 85%;
}
.compare-institution .compare-list .compare-item-filled .basic-stat-institution .statistic-item {
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3px;
}
.compare-institution .compare-list .compare-item-filled .basic-stat-institution .statistic-item .ant-progress-steps-item {
  width: 8px !important;
  border-radius: 50%;
}
.compare-institution .compare-list .compare-item-filled .basic-stat-institution .statistic-item-max .ant-progress-steps-item-active {
  background: #22bb33;
}
.compare-institution .compare-list .compare-item-filled .department-select {
  position: absolute;
  bottom: 90px;
}
.compare-institution .compare-list .compare-item-filled button {
  position: absolute;
  bottom: 10px;
  width: 170px;
  height: 45px;
  border: none;
  background-color: var(--explore-color);
  color: white;
  border-radius: 20px;
  cursor: pointer;
  margin-bottom: 20px;
}

.add-compare-button .add-compare-path {
  stroke: #28303f;
}

.add-compare-button-check {
  fill: var(--benchmarking-color);
}
.add-compare-button-check .add-compare-path {
  stroke: #28303f;
}

.no-add {
  border: 1px solid var(--benchmarking-color);
  border-radius: 50%;
  fill: var(--benchmarking-color);
}
.no-add .add-compare-path {
  stroke: white;
  fill: var(--benchmarking-color);
}

.add-compare-button:hover {
  cursor: pointer;
  border: 1px solid var(--benchmarking-color);
  border-radius: 50%;
  fill: var(--benchmarking-color);
}
.add-compare-button:hover .add-compare-path {
  stroke-width: 1.5;
  stroke: white;
}

.data-content {
  height: 45vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

.data-content::-webkit-scrollbar-track {
  background-color: transparent;
}

.data-content::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}

.data-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: var(--light-grey);
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/CompareInstitution.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAAE;EACE,eAAA;AAEJ;AAAE;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;AAEJ;AADI;EACE,kBAAA;EACA,UAAA;EACA,2CAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AAGN;AAFM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AAIR;AAHQ;EACE,UAAA;EACA,aAAA;AAKV;AAFM;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,2CAAA;EACA,mBAAA;EACA,mBAAA;AAIR;AAFM;EACE,eAAA;EACA,2CAAA;EACA,YAAA;AAIR;AADI;EACE,kBAAA;EACA,UAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAGN;AAFM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAIR;AAHQ;EACE,eAAA;EACA,uBAAA;EACA,0BAAA;AAKV;AAFM;EACE,YAAA;EACA,iBAAA;AAIR;AADM;EACE,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAGR;AADM;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;AAGR;AAFQ;EACE,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAIV;AAHU;EACE,qBAAA;EACA,kBAAA;AAKZ;AADU;EACE,mBAAA;AAGZ;AACM;EACE,kBAAA;EACA,YAAA;AACR;AACM;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,sCAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AACR;;AAKE;EACE,eAAA;AAFJ;;AAKA;EACE,+BAAA;AAFF;AAGE;EACE,eAAA;AADJ;;AAIA;EACE,2CAAA;EACA,kBAAA;EACA,+BAAA;AADF;AAEE;EACE,aAAA;EACA,+BAAA;AAAJ;;AAGA;EACE,eAAA;EACA,2CAAA;EACA,kBAAA;EACA,+BAAA;AAAF;AACE;EACE,iBAAA;EACA,aAAA;AACJ;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AACA;EACE,6BAAA;AAEF;;AACA;EACE,UAAA;EACA,6BAAA;AAEF;;AACA;EACE,mBAAA;EACA,mCAAA;AAEF","sourcesContent":[".compare-institution {\n  width: 100%;\n  .header {\n    font-size: 40px;\n  }\n  .compare-list {\n    margin-top: 20px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    .compare-item {\n      position: relative;\n      width: 24%;\n      border: 1px solid var(--benchmarking-hover);\n      background: var(--benchmarking-hover);\n      padding: 10px;\n      border-radius: 20px;\n      height: 60vh;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: space-between;\n      .icon {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        svg {\n          width: 50%;\n          height: 120px;\n        }\n      }\n      button {\n        position: absolute;\n        bottom: 10px;\n        width: 170px;\n        height: 45px;\n        border: 1px solid var(--benchmarking-color);\n        border-radius: 20px;\n        margin-bottom: 20px;\n      }\n      button:hover {\n        cursor: pointer;\n        background-color: var(--benchmarking-color);\n        color: white;\n      }\n    }\n    .compare-item-filled {\n      position: relative;\n      width: 24%;\n      background: var(--benchmarking-hover);\n      padding: 10px;\n      border-radius: 20px;\n      height: 60vh;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      .filters-keyword {\n        width: 100%;\n        display: flex;\n        align-items: flex-start;\n        flex-wrap: wrap;\n        p {\n          font-size: 14px;\n          color: var(--dark-grey);\n          margin-top: 4px !important;\n        }\n      }\n      img {\n        height: 50px;\n        object-fit: cover;\n      }\n\n      .name {\n        margin-top: 10px !important;\n        font-size: 16px;\n        font-weight: 600;\n        text-align: center;\n      }\n      .basic-stat-institution {\n        position: absolute;\n        top: 130px;\n        margin-top: 10px;\n        width: 85%;\n        .statistic-item {\n          font-size: 13px;\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          margin-bottom: 3px;\n          .ant-progress-steps-item {\n            width: 8px !important;\n            border-radius: 50%;\n          }\n        }\n        .statistic-item-max {\n          .ant-progress-steps-item-active {\n            background: #22bb33;\n          }\n        }\n      }\n      .department-select {\n        position: absolute;\n        bottom: 90px;\n      }\n      button {\n        position: absolute;\n        bottom: 10px;\n        width: 170px;\n        height: 45px;\n        border: none;\n        background-color: var(--explore-color);\n        color: white;\n        border-radius: 20px;\n        cursor: pointer;\n        margin-bottom: 20px;\n      }\n    }\n  }\n}\n.add-compare-button {\n  .add-compare-path {\n    stroke: #28303f;\n  }\n}\n.add-compare-button-check {\n  fill: var(--benchmarking-color);\n  .add-compare-path {\n    stroke: #28303f;\n  }\n}\n.no-add {\n  border: 1px solid var(--benchmarking-color);\n  border-radius: 50%;\n  fill: var(--benchmarking-color);\n  .add-compare-path {\n    stroke: white;\n    fill: var(--benchmarking-color);\n  }\n}\n.add-compare-button:hover {\n  cursor: pointer;\n  border: 1px solid var(--benchmarking-color);\n  border-radius: 50%;\n  fill: var(--benchmarking-color);\n  .add-compare-path {\n    stroke-width: 1.5;\n    stroke: white;\n  }\n}\n.data-content {\n  height: 45vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.data-content::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.data-content::-webkit-scrollbar {\n  width: 5px;\n  background-color: transparent;\n}\n\n.data-content::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  background-color: var(--light-grey);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
